import PartnerIndex from "../views/partner/HomeIndex.vue";
import Channel from "../views/partner/Channel.vue";
import ProjectReport from "../views/partner/ProjectReport.vue";
import Detail from "../views/partner/Details.vue";
import Course from "../views/partner/Course.vue";
import IndustryIndex from "../views/partner/Industry/Index.vue";
import IndustryPage from "../views/partner/Industry/Industry.vue";
import IndustryApply from "../views/partner/Industry/Apply.vue";
import Index from "../views/partner/Index.vue";
import Supplier from "@/zh-website/src/views/partner/supplier.vue";
import LiabilityExemption from "@/zh-website/src/views/partner/supplier/LiabilityExemption.vue";
import AboutPurchase from "@/zh-website/src/views/partner/supplier/AboutPurchase.vue";
import AntiCorruption from "@/zh-website/src/views/partner/supplier/AntiCorruption.vue";
import SupplierRegister from "@/zh-website/src/views/partner/supplier/SupplierRegister.vue";
import Bidding from "@/zh-website/src/views/partner/supplier/Bidding.vue";
import BiddingSubmit from "@/zh-website/src/views/partner/supplier/BiddingSubmit.vue";
import BiddingDownload from "@/zh-website/src/views/partner/supplier/BiddingDownload.vue";

export const PartnerRoute = {
  path: "/partner",
  name: "Partner",
  component: Index,
  meta: { type: 3, title: "合作用户-浙江华为门户网站", serial: 1 },
  redirect: "/partner/page",
  children: [
    {
      path: "/partner/page",
      name: "Index",
      component: PartnerIndex,
      meta: {
        type: 3,
        title: "合作用户-浙江华为门户网站",
        serial: 1
      }
    },
    {
      path: "/partner/details/:id",
      name: "Details",
      component: Detail,
      meta: {
        type: 3,
        title: "合作案例详情-浙江华为门户网站",
        serial: 8
      }
    },
    {
      path: "/partner/industry",
      name: "Industry",
      component: IndustryPage,
      meta: {
        type: 3,
        title: "行业专家合作-浙江华为门户网站",
        serial: 2
      },
      redirect: "/partner/industry/page/:type",
      children: [
        {
          path: "/partner/industry/page/:type",
          name: "Index",
          component: IndustryIndex,
          meta: {
            type: 3,
            title: "行业专家合作-浙江华为门户网站",
            serial: 2
          }
        },
        {
          path: "/partner/industry/apply",
          name: "Apply",
          component: IndustryApply,
          meta: {
            type: 3,
            title: "行业专家申请-浙江华为门户网站",
            serial: 2
          }
        }
      ]
    },
    {
      path: "/partner/course/:type",
      name: "Course",
      component: Course,
      meta: {
        type: 3,
        title: "精品课程合作-浙江华为门户网站",
        serial: 2
      }
    },
    {
      path: "/partner/channel/:type",
      name: "Channel",
      component: Channel,
      meta: {
        type: 3,
        title: "渠道合作-浙江华为门户网站",
        serial: 3
      }
    },
    {
      path: "/partner/project-report",
      name: "ProjectReport",
      component: ProjectReport,
      meta: {
        type: 3,
        title: "伙伴项目报备-浙江华为门户网站",
        serial: 3,
        keepAlive: true
      }
    },
    {
      path: "/partner/supplier",
      name: "Supplier",
      component: Supplier,
      meta: {
        type: 3,
        title: "供应商专区-浙江华为门户网站",
        serial: 4
      }
    },
    {
      path: "/partner/liability-exemption",
      name: "LiabilityExemption",
      component: LiabilityExemption,
      meta: {
        type: 3,
        title: "免责声明-浙江华为门户网站",
        serial: 4
      }
    },
    {
      path: "/partner/anti-corruption",
      name: "AntiCorruption",
      component: AntiCorruption,
      meta: {
        type: 3,
        title: "反腐败政策-浙江华为门户网站",
        serial: 4
      }
    },
    {
      path: "/partner/about-purchase",
      name: "AboutPurchase",
      component: AboutPurchase,
      meta: {
        type: 3,
        title: "关于采购-浙江华为门户网站",
        serial: 4
      }
    },
    {
      path: "/partner/supplier-register",
      name: "SupplierRegister",
      component: SupplierRegister,
      meta: {
        type: 3,
        title: "供应商登记-浙江华为门户网站",
        serial: 4,
        keepAlive: true
      }
    },
    {
      path: "/partner/supplier/bidding/:id",
      name: "Bidding",
      component: Bidding,
      meta: {
        type: 3,
        title: "邀标-浙江华为门户网站",
        serial: 4,
        keepAlive: true
      }
    },
    {
      path: "/partner/supplier/bidding/:id/submit",
      name: "BiddingSubmit",
      component: BiddingSubmit,
      meta: {
        type: 3,
        title: "邀标信息确认-浙江华为门户网站",
        serial: 4,
        keepAlive: true
      }
    },
    {
      path: "/partner/supplier/bidding/:id/download",
      name: "BiddingDownload",
      component: BiddingDownload,
      meta: {
        type: 3,
        title: "邀标信息确认-浙江华为门户网站",
        serial: 4,
        keepAlive: true
      }
    }
  ]
};
